<script setup lang="ts"></script>

<template>
    <button class="button-validate-option-value-happy">Valider</button>
</template>

<style scoped>
.button-validate-option-value-happy {
    @apply bg-button-yellow-happy-light flex items-center rounded px-3 py-1 text-text-dark-happy-light font-semibold;
}
</style>
